import { get } from "core-js/core/dict";
import request from "../../request";

export default {
  actions: {
    smsManagement() {
      return request.get('sms-management');
    },
    sendSMS(_, payload) {
      return request.post('send-sms', payload);
    },

  }
}
